import * as React from "react";

import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";

import "react-international-phone/style.css";

import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";

import MultiDropdownApi from "../../components/MultiDropdownApi";

import { siteSubContractorAdd, siteSubContractorUpdate } from "../../service/subContractorService";


export default function SubContractorSiteAdd(modalProps: any) {
  const record = modalProps.record;

  const subcontractor = modalProps.subContractor;

  async function EmployeeAdd() {
    let createObject: any = {
      subcontractor,
      appointment,
      siteId: site,
    };
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      siteSubContractorUpdate(createObject, record.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Sub Contractor Updated Successfully",
          life: 3000,
        });
        modalProps.setReload(!modalProps.reload);
        modalProps.setVisible(false);
      });
      return;
    }
    siteSubContractorAdd(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Sub Contractor Added Successfully",
        life: 3000,
      });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    });
  }

  const [appointment, setAppointment] = React.useState(record?.appointment || "");
  const [site, setSite] = React.useState(record?.site || "");

  return (
    <React.Fragment>
      <Stack direction="row" spacing={3} sx={{ display: { xs: "none", md: "flex" }, my: 1 }}>
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: "100%" }}>
          <Stack spacing={1}>
            <DropdownApi
              apiPath="site-list"
              optionLabel="name"
              optionValue="id"
              label="Site"
              selectedData={site}
              setSelectedData={setSite}
            />
          </Stack>
          <Stack spacing={1}>
            <MultiDropdownApi
              apiPath="appointments"
              queryParams={{ subcontractorId: subcontractor }}
              optionLabel="name"
              optionValue="id"
              label="Appointment"
              selectedData={appointment}
              setSelectedData={setAppointment}
            />
          </Stack>
        </Stack>
      </Stack>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => EmployeeAdd()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
